import { ConfigFilterItem, ConfigItem } from 'Core/interfaces/filters'

import { TaxRate } from './TaxCategory'

export enum CountySearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByCode = 'searchByCode',
	searchByStateAbbreviation = 'searchByStateAbbreviation',
	searchByStateName = 'searchByStateName'
}

export enum CountyFilterFields {
	includeInactive = 'includeInactive'
}
export declare namespace County {
	interface Option extends Entity {
		stateCode: string
	}

	interface Basic extends Entity, NameCode {
		stateAbbreviation: string
		country: string
		isActive: boolean
	}

	interface Detailed extends NameCode {
		id: Key
		stateProvince: Entity
		isActive: boolean
		taxRates: TaxRate.Detailed[]
	}

	namespace Form {
		interface Generic extends NameCode {
			stateProvinceId: number | null
			isActive: boolean
			taxRates: TaxRate.Form.Generic[]
		}
	}
	namespace Request {
		interface Generic extends NameCode {
			stateProvinceId: number | null
			isActive: boolean
		}
	}

	namespace Search {
		interface Config {
			[CountySearchFields.searchById]: ConfigItem<CountySearchFields>
			[CountySearchFields.searchByName]: ConfigItem<CountySearchFields>
			[CountySearchFields.searchByCode]: ConfigItem<CountySearchFields>
			[CountySearchFields.searchByStateName]: ConfigItem<CountySearchFields>
			[CountySearchFields.searchByStateAbbreviation]: ConfigItem<CountySearchFields>
		}
		interface Result {
			[CountySearchFields.searchById]: number[]
			[CountySearchFields.searchByName]: string[]
			[CountySearchFields.searchByCode]: string[]
			[CountySearchFields.searchByStateName]: string[]
			[CountySearchFields.searchByStateAbbreviation]: string[]
		}
	}
	namespace Filter {
		interface Config {
			[CountyFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
		}
	}
}
